import { createSelector } from "reselect";

import { AppState } from "reducers";
import { PageListReduxState } from "reducers/entityReducers/pageListReducer";

import { getActions } from "sagas/selectors";

// Widget/canvas runtime removed in modernization. Types aliased to `any`.
type CanvasWidgetsReduxState = any;

const getPageListState = (state: AppState) => state.entities.pageList;
export const getDataSources = (state: AppState) =>
  state.entities.datasources.list;

export const getInstalledTemplateList = (state: AppState) =>
  state.entities.datasources.installedTemplateList;

export const getProviderCategories = (state: AppState) =>
  (state.ui as any).providers?.providerCategories;

export const getIsEditorInitialized = (state: AppState) =>
  state.ui.editor.initialized;

export const getIsEditorInitializeError = (state: AppState): boolean =>
  state.ui.editor.initializationError;

export const getIsEditorLoading = (state: AppState) =>
  state.ui.editor.loadingStates.loading;

export const getCurrentApplicationLayoutSettings = (state: AppState) =>
  state.ui.applications.currentApplication?.global_setting;

export const getIsFetchingPage = (state: AppState) =>
  state.ui.editor.loadingStates.isPageSwitching;

export const getLoadingError = (state: AppState) =>
  state.ui.editor.loadingStates.loadingError;

export const getIsPageSaving = (state: AppState) => {
  return state.ui.editor.loadingStates.saving;
};

export const getIsPublishingApplication = (state: AppState) =>
  state.ui.editor.loadingStates.publishing;

export const getPublishingError = (state: AppState) =>
  state.ui.editor.loadingStates.publishingError;

export const getCurrentLayoutId = (state: AppState) =>
  state.ui.editor.currentLayoutId;

export const getPageList = (state: AppState) => state.entities.pageList.pages;

export const getCurrentPageId = (state: AppState) =>
  state.entities.pageList.currentPageId;

export const getCurrentApplicationId = (state: AppState) =>
  state.entities.pageList.applicationId;

export const getCurrentPlugins = (state: AppState) =>
  state.entities.plugins.list;

export const getCurrentGlobalStore = (state: AppState) =>
  state.entities.app.globalStore;

export const getCurrentGlobalUser = (state: AppState) =>
  state.entities.app.user;

export const getCurrentPageName = createSelector(
  getPageListState,
  (pageList: PageListReduxState) =>
    pageList.pages.find(page => page.pageId === pageList.currentPageId)
      ?.pageName,
);

export const getActionById = createSelector(
  [getActions, (state: any, props: any) => props.match.params.apiId],
  (actions, id) => {
    const action = actions.find(action => action.config.id === id);
    if (action) {
      return action.config;
    } else {
      return undefined;
    }
  },
);
